import { type ReactElement } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { Ga4PropertySelect } from '@/components/connectors/ga4-property-select';
import { ROUTES } from '@/constants/routes';
import { loadNamespaces } from '@/lib/i18n/i18n';

const searchSchema = z.object({
  pending: z.string().min(1),
  from: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/connect-ga4-property')({
  loader: () => loadNamespaces('settings'),
  validateSearch: searchSchema,
  staticData: { hideAppShell: true, title: 'route.connect_ga4_property.title' },
  component: ConnectGa4PropertyPage,
});

function ConnectGa4PropertyPage(): ReactElement {
  const { pending, from } = Route.useSearch();
  return (
    <div className="bg-bg-page flex min-h-svh items-center justify-center p-6">
      <Ga4PropertySelect
        pending={pending}
        redirectTo={from ?? ROUTES.CONNECTORS}
        className="w-full max-w-md"
      />
    </div>
  );
}
